// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Snooze scadenze ======
// Sposta in avanti la data di una scadenza esistente. Giorni richiesti: 1/2/5/7/14/30.

const SNOOZE_OPTIONS = [
  { label: '+1 giorno', days: 1 },
  { label: '+2 giorni', days: 2 },
  { label: '+5 giorni', days: 5 },
  { label: '+7 giorni', days: 7 },
  { label: '+14 giorni', days: 14 },
  { label: '+30 giorni', days: 30 }
];

function addDaysIso(iso, days) {
  if (!iso) return '';
  const d = new Date(iso + (iso.length === 10 ? 'T00:00:00' : ''));
  if (isNaN(d)) return iso;
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

async function snoozeScadenza(clienteName, scadenzaId, days) {
  if (!isAdmin()) return;
  const cli = state.clients.find((c) => c.nome === clienteName);
  if (!cli) {
    toast('Cliente non trovato');
    return;
  }
  const sc = (cli.scadenze || []).find((s) => s.id === scadenzaId);
  if (!sc) {
    toast('Scadenza non trovata');
    return;
  }
  const oldDate = sc.data;
  const newDate = addDaysIso(sc.data || new Date().toISOString().slice(0, 10), days);
  sc.data = newDate;

  // Persiste TUTTE le scadenze del cliente con la stessa shape api.saveClient
  try {
    await api.saveClient(cli, cli.nome);
    // S2: ricarica solo il cliente snoozzato
    await refreshClient(cli.nome);
    logAudit({
      action: 'update',
      entity: 'Scadenza',
      target: `${cli.nome} · ${sc.titolo}`,
      changes: [{ field: 'Data', from: oldDate || '(vuoto)', to: newDate }],
      details: `Snooze ${days} giorni`
    });
    renderAll();
    toast(`Scadenza spostata di ${days} giorni`);
  } catch (e) {
    console.error(e);
    sc.data = oldDate; // rollback in memoria
    toast('Errore snooze: ' + (e.message || e));
  }
}

// Crea un popover snooze attaccato a un trigger button
function attachSnoozePopover(triggerBtn, clienteName, scadenzaId) {
  // Rimuovi popover esistenti
  document.querySelectorAll('.snooze-popover').forEach((p) => p.remove());

  const wrap = document.createElement('div');
  wrap.className = 'snooze-popover open';
  wrap.innerHTML = SNOOZE_OPTIONS.map(
    (opt) => `<button type="button" data-snooze="${opt.days}">${opt.label}</button>`
  ).join('');

  // Posiziona accanto al trigger
  const parent = triggerBtn.closest('.snooze-trigger-wrap') || triggerBtn.parentElement;
  if (parent && getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
  parent.appendChild(wrap);

  wrap.querySelectorAll('button').forEach((b) => {
    b.addEventListener('click', async (e) => {
      e.stopPropagation();
      const d = parseInt(b.dataset.snooze, 10);
      wrap.remove();
      await snoozeScadenza(clienteName, scadenzaId, d);
    });
  });

  // Chiude al click fuori
  const onDocClick = (e) => {
    if (!wrap.contains(e.target) && e.target !== triggerBtn) {
      wrap.remove();
      document.removeEventListener('click', onDocClick);
    }
  };
  setTimeout(() => document.addEventListener('click', onDocClick), 0);
}

Object.assign(globalThis, { attachSnoozePopover, snoozeScadenza });
export {};
